import type { IconData } from '@stacksjs/iconify-core'

export const watch: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M349.279 16H162.721l-24.772 132.116a159.7 159.7 0 0 0 0 215.768L162.721 496h186.558l24.772-132.116a159.7 159.7 0 0 0 0-215.768Zm-160 32h133.442l13 69.311a159.75 159.75 0 0 0-159.434 0Zm133.442 416H189.279l-13-69.311a159.75 159.75 0 0 0 159.434 0ZM256 384a128 128 0 1 1 128-128a128.145 128.145 0 0 1-128 128\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default watch
